







































































































import { CourierServiceCodesConfigurationDto } from "@/model/data.model";
import { CourierBusiness } from "@/model/enumeration.model";
import { isAustria, isGermany } from "@/services/Helpers";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TrackingService from "../../../services/TrackingService";
import { ShipmentService } from "@/services/ShipmentService";

@Component({ components: {} })
export default class TrackingModal extends Vue {
  @Prop() shipment: any;

  trackingResults: any[] = [];
  trackingService: TrackingService;

  created() {
    this.trackingService = new TrackingService();
    this.trackingResults = [];
    this.loadData(0);
  }

  loadData(page: number) {
    let tracking = this.shipment.mbeTracking;
    let isWine = false;
    if (!tracking || tracking == "") {
      tracking = this.shipment.shipmentPackages[0].mbePackTrackingNumber;
      isWine = true;
    }
    this.trackingService
      .getTracking(undefined, tracking, page)
      .then(trackingDto => {
        if (isWine) {
          trackingDto.shipments = trackingDto.shipments.filter(ship => {
            return (
              !ship.trackingNumberShipment && ship.trackingNumberShipment != ""
            );
          });
        }
        const results: any[] = (trackingDto.shipments as any[]).map(value => {
          //merge package and tracking data
          return {
            ...this.shipment.shipmentPackages.find(
              pack => pack.mbePackTrackingNumber === value.mbePackTrackingNumber
            ),
            ...value
          };
        });
        this.trackingResults = this.trackingResults.concat(results);
        if (trackingDto.number < trackingDto.totalPages - 1) {
          //load next pages until last
          this.loadData(trackingDto.number + 1);
        }
      });
  }

  async getTrackingLink(row: any) {
    let agencyCode = undefined;
    let clientCode = undefined;

    if (this.shipment.courierId === CourierBusiness.CTT) {
      const cttAccountList: CourierServiceCodesConfigurationDto[] = await ShipmentService.getAccounts(
        this.shipment.courierId
      );

      if (cttAccountList.length > 0) {
        const cttAccount = cttAccountList[0];
        const agencyCodeParameter = cttAccount.additionalParameters.find(
          parameter => parameter.key === "agency_client_code"
        );
        const clientCodeParameter = cttAccount.additionalParameters.find(
          parameter => parameter.key === "agency_client_number"
        );

        if (agencyCodeParameter && clientCodeParameter) {
          agencyCode = agencyCodeParameter.value;
          clientCode = clientCodeParameter.value;
        }
      }
    }

    TrackingService.prototype
      .getTrackingUrls(
        row.packTrackingNumber
          ? row.packTrackingNumber
          : row.shipmentTrackingNumber,
        row.courierName,
        this.shipment.addressTo.zipCode,
        agencyCode,
        clientCode
      )
      .then(url => {
        window.open(url, "_blank");
      });
  }

  getLinkToWebTracking(row: any) {
    if (
      isAustria() &&
      this.$store.getters["customer/config"].courierTrackingNumberVisible
    ) {
      const url = this.trackingService.getCourierTrackinUrls([this.shipment]);
      if (url) return url;
    }

    if (
      isGermany() &&
      this.$store.getters["customer/config"].courierTrackingNumberVisible &&
      this.shipment.courierId == CourierBusiness.IDS
    ) {
      const url = this.trackingService.getCourierTrackinUrls([this.shipment]);
      if (url) return url;
    }

    const country = this.$store.getters["customer/storeInfo"].store.storeCode
      .substring(0, 2)
      .toUpperCase();

    return this.trackingService.getTrackingMBEURL(
      row["mbePackTrackingNumber"] || row["trackingNumberShipment"],
      country
    );
  }

  closeModal() {
    this.$emit("close", false);
  }
}
